function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.526 1c.29 0 .526.236.526.526v2.782a7.001 7.001 0 0112.894 2.818.526.526 0 01-1.044.13 5.95 5.95 0 00-11.066-2.21h2.736a.526.526 0 010 1.052H1.526A.526.526 0 011 5.572V1.526c0-.29.236-.526.526-.526zm-.015 7.287a.526.526 0 01.587.457 5.95 5.95 0 0011.066 2.21h-2.736a.526.526 0 010-1.052h4.046c.29 0 .526.235.526.526v4.046a.526.526 0 01-1.052 0v-2.782A7.001 7.001 0 011.054 8.874a.526.526 0 01.457-.587z",
  fill: "#2D2D2D"
});
function SvgActualizar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Actualizar.svg";
export { SvgActualizar as ReactComponent };